import { Button, ButtonColors } from '@chiroup/components/Button';
import { OpenClosedStates } from '@chiroup/core/enums/OpenClosedStates.enum';
import React, { useState } from 'react';
import { useAdminPermissions } from '../../hooks/useAdminPermissions';
import ClinicCreateModal from './ClinicCreateModal';

type Props = {
  onCreate: () => void;
  user: any;
};

const ClinicCreate: React.FC<Props> = ({ onCreate, user }) => {
  const [state, setState] = useState<OpenClosedStates>(OpenClosedStates.Closed);
  const { hasPermission } = useAdminPermissions();

  const open = () => {
    setState(OpenClosedStates.Open);
  };

  const close = () => {
    setState(OpenClosedStates.Closed);
  };

  return (
    <>
      <ClinicCreateModal state={state} close={close} onCreate={onCreate} user={user} />
      {hasPermission('clinic.create') && (
        <Button
          text="Add"
          color={ButtonColors.plainWithBorder}
          className="cursor-pointer"
          onClick={open}
        />
      )}
    </>
  );
};

export default ClinicCreate;
